import {
  CMSArrayBase,
  CMSGroupParams,
  CMSImageBase,
  CMSScheduler,
} from './base';

export enum ButtonType {
  Deposit = 'deposit',
  Link = 'link',
  None = 'none',
  ShowMore = 'show_more',
  Explore = 'explore',
  ReadMore = 'read_more',
  JoinNow = 'join_now',
  t = 'play_now',
}

export interface Slide extends CMSArrayBase, CMSGroupParams, CMSScheduler {
  title: string;
  description: string;
  buttonType: ButtonType;
  buttonLink: string;
  backgroundDesktop: CMSImageBase;
  backgroundMobile: CMSImageBase;
  charactersDesktop: CMSImageBase;
  charactersMobile: CMSImageBase;
  showAllUsers: boolean;
  order: number;
}

export interface SlideBenefit {
  text: string;
  textV2: string;
  crossSellText?: string;
  icon: CMSImageBase;
  iconV2: CMSImageBase;
}

export interface RegistrationSlide {
  benefits?: SlideBenefit[];
  order: number;
  title: string;
  backgroundDesktop: CMSImageBase;
  backgroundMobile: CMSImageBase;
  charactersDesktop: CMSImageBase;
  charactersMobile: CMSImageBase;
  titleColor?: string;
}
